export const UpcomingPaymentsActionTypes = {
  fetchUpcomingPayments: 'fetchUpcomingPayments',
  fetchUpcomingPaymentsTotals: 'fetchUpcomingPaymentsTotals',
  fetchUpcomingPaymentsTotalsSuccess: 'fetchUpcomingPaymentsTotalsSuccess',
  fetchUpcomingPaymentsTotalsFailed: 'fetchUpcomingPaymentsTotalsFailed',
};
